import { planTypes } from '@/common/constants';

export default {
  data() {
    return {
      logo: require('@/assets/plans/visitor_management.svg'),
      title: this.$t('billing.visitor_management.title'),
      planType: planTypes.VISITOR_MANAGEMENT,
    };
  },
};
